import axios from "axios";

const PREFIJO = "/api/Frmlr/"

export default {
    modeloComercial(){
        const dto = {}
        return axios.post(`${PREFIJO}VmCbMc`,dto);
    }
}